import "./App.css";
import MainBody from "./Components/MainBody/MainBody";

function App() {
  return (
    <div className="app">
      <MainBody />
    </div>
  );
}

export default App;
